export default "__VITE_ASSET__D84baNR4__"